import React from 'react';
import Button from '@material-ui/core/Button';
import { useForm } from 'react-hook-form';
import { Box } from '@mui/material';

import Modal, {
  ModalContents,
  ModalTitle,
  ModalButton,
  ModalTypography,
} from 'components/Modal/Modal';
import { controlledTextField } from 'components/ReactHookForm/controlledTextField';

interface ImpersonationModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { impersonationReason: string }) => void;
  userName: string;
}

interface FormData {
  impersonationReason: string;
}

const ImpersonationReasonInput = controlledTextField<Required<FormData>>()('impersonationReason', {
  rules: {
    required: 'Please provide a reason for impersonation',
    minLength: {
      value: 5,
      message: 'Reason must be at least 5 characters long',
    },
    maxLength: {
      value: 500,
      message: 'Reason must be less than 500 characters',
    },
  },
});

const ImpersonationModal = ({ open, onClose, onSubmit, userName }: ImpersonationModalProps) => {
  const { control, reset, handleSubmit } = useForm<FormData>({
    defaultValues: {
      impersonationReason: '',
    },
    mode: 'onChange',
  });

  const handleSubmitActual = handleSubmit((data) => {
    onSubmit(data);
    reset();
  });

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <ModalContents
        onClickClose={handleClose}
        body={
          <>
            <ModalTitle>Impersonate {userName}</ModalTitle>
            <ModalTypography>
              You will be temporarily signed in as {userName} and can perform actions on their
              behalf. All actions will be logged and visible to the user in their activity history.
            </ModalTypography>
            <ImpersonationReasonInput
              controllerProps={{ control }}
              helperText="Describe why you need to access this user's account (e.g., troubleshooting issue, providing support)…"
              multiline
              minRows={3}
              label="Reason for Access"
              type="text"
              fullWidth
            />
          </>
        }
        actions={
          <Box>
            <Button onClick={handleClose} color="default" style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <ModalButton onClick={handleSubmitActual}>Impersonate</ModalButton>
          </Box>
        }
      />
    </Modal>
  );
};

export default ImpersonationModal;
